import api from "../config/api"



export const getAttributesItems = async () => {
    return await api().get('/attributeItem/')
}

